<p-toast position="top-right" key="save"></p-toast>
<div class="fixed transform z-5" *ngIf="showProgressSpinner">
    <app-custom-spinner></app-custom-spinner>
</div>
<div class="bg-default px-3 pb-3" id="htmldata" #htmldata>
    <div class="flex justify-content-between align-items-center title-bg title-case" style="margin-bottom: 5px;">
        <div class="conten">
            <div class="btn"><a>MRS</a></div>
        </div>
    </div>
    <div class="grid justify-content-end">
        <div class="col-12 md:col-6 lg:col-2">
            <label><b>System</b></label>
            <p-dropdown [options]="SelectSystemData" (click)="GetAllData('system')" (onChange)="OnChangeSystemFilter()"
                [(ngModel)]="selectedSystem" optionLabel="Text" [filter]="true" filterBy="Text"
                placeholder="-- Select --" optionValue="Value" class="mr-2"></p-dropdown>
        </div>
        <div class="col-12 md:col-6 lg:col-2">
            <label><b>Regional</b></label>
            <p-dropdown [options]="SelectRegionData" optionLabel="Text" (click)="GetAllData('regional')"
                (onChange)="OnChangeRegionalFilter()" [(ngModel)]="selectedRegional" [filter]="true" filterBy="Text"
                placeholder="-- Select --" optionValue="Value" class="mr-2"></p-dropdown>
        </div>
        <div class="col-12 md:col-6 lg:col-2">
            <label><b>Facility</b></label>
            <!-- (click)="GetAllData('facility')" -->
            <p-multiSelect class="w-full" [options]="SelectFacilityData" 
                placeholder="-- Select --" optionLabel="Text" display="chip" optionValue="Value"
                [(ngModel)]="selectedFacility">
            </p-multiSelect>
        </div>
        <div class="col-12 md:col-6 lg:col-2">
            <label><b>QPS</b></label>
            <p-multiSelect class="w-full" [options]="SelectQPSData" (click)="GetAllData('qps')"
                placeholder="-- Select --"  optionLabel="Text" display="chip"
                optionValue="Value" [(ngModel)]="selectedQPS"></p-multiSelect>
        </div>
        <div class="col-12 md:col-6 lg:col-2">
            <label><b>Date Type</b></label>
            <p-dropdown [options]="dateTypeOptions" optionLabel="Text" [(ngModel)]="selectedDateType" [filter]="true"
                filterBy="Text" optionValue="value" class="mr-2"></p-dropdown>
        </div>
        <div class="col-12 md:col-6 lg:col-2">
            <label><b>Action</b></label>
            <p-multiSelect class="w-full" [options]="actionOptions" defaultLabel="Select Action"
                optionLabel="Text" display="chip" optionValue="value" [(ngModel)]="selectedActionType"
                [filter]="true" filterBy="Text">
            </p-multiSelect>
        </div>
        <div class="col-12 md:col-6 lg:col-2">
            <label for="FirstName"><b [ngStyle]="textStrtColorBool ? {'color':'red','font-size':'15px'} : {'color':'black'}">
                From Date:</b></label>
            <p-calendar [(ngModel)]="txtStartDate" [minDate]="minDate" [showIcon]="true" inputId="icon" class="mr-2">
            </p-calendar>
        </div>
        <div class="col-12 md:col-6 lg:col-2">
            <label for="FirstName"><b [ngStyle]="textEndColorBool ? {'color':'red','font-size':'15px'} : {'color':'black'}">
                To Date:</b></label>
            <p-calendar [(ngModel)]="txtEndDate" [showIcon]="true" inputId="icon" class="mr-2">
            </p-calendar>
        </div>
        <div class="col-12 md:col-6 lg:col-2">
            <label><b>Participates in RAPIDI</b></label>
            <p-multiSelect class="w-full" [options]="ParticipateInRapidiOptions" optionLabel="Text" display="chip"
                [(ngModel)]="selectedParticipatesInRapidi" [filter]="true" filterBy="Text" optionValue="value"
                class="mr-2" defaultLabel="-- Select Participated --"></p-multiSelect>
        </div>
    </div>
    <div class="md:col-12 px-0">
        <!-- Search Filters SelectEnd -->
        <div class="flex justify-content-end mb-2" id="search_chart_excel_btn">
            <p-button *ngIf="dataForExcelBool" label="Export to Excel" icon="pi pi-upload" (click)="exportExcel()" [loading]="exportExcelLoader"
            class="p-button-primary mr-2 export-largescreen"></p-button>
            <!-- Search and Export button start -->
            <p-button label="Search" icon="pi pi-search" (click)="GetMRSFollowUpReport()"
                [loading]="SearchLoader == true" class="p-button-primary"></p-button>
                <p-button *ngIf="clearSearchBool" label="Clear Search" icon="pi pi-times" (click)="ClearSearch()"
                class="p-button-primary"></p-button>
        </div><!-- Search and Export button end -->
    </div>

    <div class="casesGrid mt-2">
        <p-table #dt [value]="mrsData" [rows]="rows" styleClass="p-datatable-striped p-datatable-gridlines createRoles"
            sortMode="multiple" [customSort]="true"  
            [lazy]="true" responsiveLayout="scroll" [rowHover]="true" [paginator]="true" 
            dataKey="Id" [totalRecords]="totalRecords" [columns]="cols" (onPage)="lazyLoadPageSchedules($event)" (onSort)="lazyLoadSortSchedules($event)"
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries" [resetPageOnSort]="false"
            [showCurrentPageReport]="true" [rowsPerPageOptions]="[10,15,25,50,totalRecords]" [resizableColumns]="true"
            columnResizeMode="expand">
            <ng-template pTemplate="header">
                <tr>
                    <th pSortableColumn="CaseNumber" pResizableColumn>Case Number
                        <p-sortIcon field="CaseNumber"></p-sortIcon>
                    </th>
                    <th pSortableColumn="DateofConsult" pResizableColumn>Consult Date
                        <p-sortIcon field="DateofConsult"></p-sortIcon>
                    </th>
                    <th pSortableColumn="FacilityID" pResizableColumn>Facility ID
                        <p-sortIcon field="FacilityID"></p-sortIcon>
                    </th>
                    <th pSortableColumn="Facility" pResizableColumn>Facility
                        <p-sortIcon field="Facility"></p-sortIcon>
                    </th>
                    <th pSortableColumn="PatientName" pResizableColumn>Patient Name
                        <p-sortIcon field="PatientName"></p-sortIcon>
                    </th>
                    <th pSortableColumn="DOB">DOB
                        <p-sortIcon field="DOB"></p-sortIcon>
                    </th>
                    <th pSortableColumn="Age">Age
                        <p-sortIcon field="Age"></p-sortIcon>
                    </th>
                    <th pSortableColumn="Gender">Gender
                        <p-sortIcon field="Gender"></p-sortIcon>
                    </th>
                    <th pSortableColumn="PhysicianId">Phyician ID
                        <p-sortIcon field="PhysicianId"></p-sortIcon>
                    </th>
                    <th pSortableColumn="Physician">Phyician
                        <p-sortIcon field="Physician"></p-sortIcon>
                    </th>
                    <th pSortableColumn="IdentificationType">Identification Type
                        <p-sortIcon field="IdentificationType"></p-sortIcon>
                    </th>
                    <th pSortableColumn="Identification">Identification
                        <p-sortIcon field="Identification"></p-sortIcon>
                    </th>
                    <th pSortableColumn="DoorToNeedle">Arrival to needle time
                        <p-sortIcon field="DoorToNeedle"></p-sortIcon>
                    </th>
                    <th pSortableColumn="Navigator">Navigator
                        <p-sortIcon field="Navigator"></p-sortIcon>
                    </th>
                    <th pSortableColumn="NightyDaysMRSValue">90 days MRS
                        <p-sortIcon field="NightyDaysMRSValue"></p-sortIcon>
                    </th>
                    <th pSortableColumn="PremorbidMRSValue">Pre Morbid MRS
                        <p-sortIcon field="PremorbidMRSValue"></p-sortIcon>
                    </th>
                    <th pSortableColumn="InitialContact1">Initial Contact Date 1
                        <p-sortIcon field="InitialContact1"></p-sortIcon>
                    </th>
                    <th pSortableColumn="ActionPremorbid1">Action 1
                        <p-sortIcon field="ActionPremorbid1"></p-sortIcon>
                    </th>
                    <th pSortableColumn="Comment1">Comments 1
                        <p-sortIcon field="Comment1"></p-sortIcon>
                    </th>
                    <th pSortableColumn="InitialContact2">Initial Contact Date 2
                        <p-sortIcon field="InitialContact2"></p-sortIcon>
                    </th>
                    <th pSortableColumn="ActionPremorbid2">Action 2
                        <p-sortIcon field="ActionPremorbid2"></p-sortIcon>
                    </th>
                    <th pSortableColumn="Comment2">Comments 2
                        <p-sortIcon field="Comment2"></p-sortIcon>
                    </th>
                    
                    <th pSortableColumn="InitialContact3">Initial Contact Date 3
                        <p-sortIcon field="InitialContact3"></p-sortIcon>
                    </th>
                    <th pSortableColumn="ActionPremorbid3">Action 3
                        <p-sortIcon field="ActionPremorbid3"></p-sortIcon>
                    </th>
                    <th pSortableColumn="Comments3">Comments 3
                        <p-sortIcon field="Comments3"></p-sortIcon>
                    </th>
                    
                    <th pSortableColumn="InitialContact4">Initial Contact Date 4
                        <p-sortIcon field="InitialContact4"></p-sortIcon>
                    </th>
                    <th pSortableColumn="ActionPremorbid4">Action 4
                        <p-sortIcon field="ActionPremorbid4"></p-sortIcon>
                    </th>
                    <th pSortableColumn="Comment4">Comments 4
                        <p-sortIcon field="Comment4"></p-sortIcon>
                    </th>
                    <th pSortableColumn="CurrentStatus">Current Status
                        <p-sortIcon field="CurrentStatus"></p-sortIcon>
                    </th>
                    <th pSortableColumn="CompletedBy">Completed by
                        <p-sortIcon field="CompletedBy"></p-sortIcon>
                    </th>
                    <th pSortableColumn="PatientSatisfactionScore">Patient Satisfaction Score
                        <p-sortIcon field="PatientSatisfactionScore"></p-sortIcon>
                    </th>
                    <th pSortableColumn="Note">Note
                        <p-sortIcon field="Note"></p-sortIcon>
                    </th>
                    <th pSortableColumn="PatientPhoneNumber">Patient Phone Number
                        <p-sortIcon field="PatientPhoneNumber"></p-sortIcon>
                    </th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-cases>
                <tr>
                    <td class="pointer">{{cases.CaseNumber}}</td>
                    <td class="pointer">{{cases.DateofConsult}}</td>
                    <td class="pointer">{{cases.FacilityID}}</td>
                    <td class="pointer">{{cases.Facility}}</td>
                    <td class="pointer">{{cases.PatientName}}</td>
                    <td class="pointer">{{cases.DOB}}</td>
                    <td class="pointer">{{cases.Age}}</td>
                    <td class="pointer">{{cases.Gender}}</td>
                    <td class="pointer">{{cases.PhysicianId}}</td>
                    <td class="pointer">{{cases.Physician}}</td>
                    <td class="pointer">{{cases.IdentificationType}}</td>
                    <td class="pointer">{{cases.Identification}}</td>
                    <td class="pointer">{{cases.DoorToNeedle}}</td>
                    <td class="pointer">{{cases.Navigator}}</td>
                    <td class="pointer">{{cases.NightyDaysMRSValue}}</td>
                    <td class="pointer">{{cases.PremorbidMRSValue}}</td>
                    <td class="pointer">{{cases.InitialContact1}}</td>
                    <td class="pointer">{{cases.ActionPremorbid1}}</td>
                    <td class="pointer">{{cases.Comment1}}</td>
                    <td class="pointer">{{cases.InitialContact2}}</td>
                    <td class="pointer">{{cases.ActionPremorbid2}}</td>
                    <td class="pointer">{{cases.Comment2}}</td>
                    <td class="pointer">{{cases.InitialContact3}}</td>
                    <td class="pointer">{{cases.ActionPremorbid3}}</td>
                    <td class="pointer">{{cases.Comment3}}</td>
                    <td class="pointer">{{cases.InitialContact4}}</td>
                    <td class="pointer">{{cases.ActionPremorbid4}}</td>
                    <td class="pointer">{{cases.Comment4}}</td>
                    <td class="pointer">{{cases.CurrentStatus}}</td>
                    <td class="pointer">{{cases.CompletedBy}}</td>
                    <td class="pointer">{{cases.PatientSatisfactionScore}}</td>
                    <td class="pointer">{{cases.Note}}</td>
                    <td class="pointer">{{cases.PatientPhoneNumber}}</td>
                </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage" let-columns>
                <tr>
                    <h5 *ngIf="totalRecords==0" class="text-center create-roles">
                        <b> No records found</b>
                    </h5>
                </tr>
            </ng-template>
        </p-table>
        <div class="md:col-12">
            <span class="tableRefreshTime">
                <!-- Grid Last Refreshed at {{analyzeService._currentDate}} - {{analyzeService._currentTime}} -->
            </span>
        </div>
    </div>
</div>